import { AssetModelData } from "../../files/asset.interface";
import { LayoutNode } from "./layout.interface";
import { resolveAssetPaths } from "./resolve-asset-paths";
import { deepFindFiles } from "./util/deep-find-files";

export const replaceLayoutAssets = (
  views: LayoutNode[],
  assets: AssetModelData[]
) => {
  const files = deepFindFiles(views);

  for (const file of files) {
    if (file.assetId) {
      const asset = assets.find((a) => a.id === file.assetId);

      if (asset) {
        Object.assign(file, resolveAssetPaths(file, asset));
      }
    }
  }
  return views;
};
